// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3hl6X","left":"InfoRow_left__37aBe"};